import { useEffect, useState } from 'react';

const usePageview = (adConsent: any): number => {
  const [pv, setPv] = useState(0);
  useEffect(() => {
    if (adConsent) {
      const newPv = pv + 1;
      setPv(newPv);
    }
  }, [adConsent]);

  return pv;
};

export default usePageview;
